import { createFileRoute } from '@tanstack/react-router'

import { HodOverviewPage } from '@/systems/issues/features/hod-inbox/components/HodOverviewPage'
import { hodInboxQueryOptions } from '@/systems/issues/features/hod-inbox/hooks/useHodInbox'

// HOD's home page. Prefetches the open bucket so the stat tiles + the
// recent activity feed land hydrated on first paint.
export const Route = createFileRoute('/hod/dashboard')({
  loader: ({ context: { queryClient } }) => {
    void queryClient.prefetchQuery(
      hodInboxQueryOptions({ bucket: 'open', page_size: 5 }),
    )
  },
  component: HodOverviewPage,
})
